import React from 'react';
import Popup from 'reactjs-popup';
import MultipleFindReplaceView from '../multipleFind/MultipleFindReplaceView';

const MultipleFindReplaceDialog_Popup = ({ _WaveformView }) => {
  return (
    <Popup
      open={_WaveformView.state.isShowMultipleFindReplace}
      modal
      closeOnDocumentClick
      onClose={() => {
        _WaveformView.setState({ isShowMultipleFindReplace: false });
      }}
      contentStyle={{ width: '550px' }}
    >
      <MultipleFindReplaceView
        handleReplace={(type, user) => {
          _WaveformView.handleReplace(type, user);
        }}
        closeMultipleFindReplaceView={() => {
          _WaveformView.setState({ isShowMultipleFindReplace: false });
        }}
        showList={() => {
          _WaveformView.setState({ isShowMultipleFindReplace: false });
          _WaveformView.isShowTranslationsNavbarAlert(false);
        }}
      />
    </Popup>
  );
};

export default MultipleFindReplaceDialog_Popup;



// WEBPACK FOOTER //
// ./src/components/popup/MultipleFindReplaceDialog_Popup.js